import { cn } from '@/utils/cn';
import NavigationItems from './components/NavigationItems/NavigationItems';

interface Props {
  isMenuMinify: boolean;
  isOpen: boolean;
  handleCloseSideBar: () => void;
  isHomePage: boolean;
}

export default function SidebarContent({ isMenuMinify, isOpen, handleCloseSideBar, isHomePage }: Props) {
  return (
    <>
      <div
        className={cn(
          'w-59.25 h-[calc(100vh-9rem)] 3xl:hidden lg:h-[calc(100vh-5rem)] max-lg:mt-16 max-lg:fixed top-0 left-0 max-lg:hidden shrink-0 transform transition-[width,translate] duration-600 ease-in-out will-change-auto',
          {
            'translate-x-0': isOpen,
            '-translate-x-full': !isOpen,
          },
        )}
      />

      <div
        className={cn(
          'fixed 3xl:mb-20 3xl:w-70 3xl:mt-5 3xl:sticky 3xl:top-21 3xl:rounded-[1.75rem] bg-c950 max-lg:h-dvh max-lg:pb-20 hide-scrollbar lg:h-[calc(100dvh-4rem)] 3xl:h-[calc(100%-7rem)] top-0 md:top-16 left-0 z-20 min-w-0',
          'transform transition-[width,translate] duration-600 ease-in-out overflow-x-hidden overflow-y-auto will-change-auto overscroll-contain 3xl:overscroll-auto',
          {
            'translate-x-0': isOpen,
            '3xl:mb-5': !isHomePage,
            'max-lg:-translate-x-full': !isOpen,
            'w-full md:w-59.25': !isMenuMinify,
          },
        )}
      >

        <NavigationItems handleCloseSideBar={handleCloseSideBar} isMenuMinify={isMenuMinify} />
      </div>
    </>
  );
}
